import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { regions } from "../../../shared/regions/regions.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface RegionChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-region-select",
  templateUrl: "./region-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class RegionSelectComponent implements OnInit {
  public readonly regionChange = output<RegionChangeEvent>();
  @Input() public region = "Select region";
  public readonly disabled = input(false);

  public subscription = new Subscription();
  public regionList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildRegionList();
  }

  public onRegionChange(event: RegionChangeEvent) {
    this.regionChange.emit(event);
  }

  private buildRegionList() {
    Object.keys(regions).map((key) => {
      this.regionList.push({
        label: regions[key],
        value: key,
      });
    });
  }
}
